import React from "react";
import { roles } from "../../../..";
import { AEMoment } from "../../../../_emywork/components/moment";


export const walletsColumns = [
  { name: "id", title: "ID", sortable: true },
  //   { name: "holder_type", title: "HOLDER_TYPE", sortable: true },

  {
    template: (d) => (

      <a
        href={`/users/${d.user}/profile`}
        target="_blank"
        rel="noopener noreferrer"

      >
        {d.user}
      </a>
    ),
    title: "WALLET.HOLDER_ID",
    sortable: true,
    acceptedRoles: [roles.super_admin],
  },
  { name: "balance", title: "BALANCE", sortable: true, type: "coins" },

  {

    template: (d) => {
      return !!d.expiry && d.expiry === "Expired" ? (
        "Expired"
      ) : (
        <AEMoment date={d.expiry} format={"L"} />
      );
    },
    title: "EXPIRY",
    sortable: true,
  },
  { name: "created_at", title: "CREATED_AT", sortable: true, type: "date" },
  { name: "updated_at", title: "UPDATED_AT", sortable: true, type: "date" },
];
